import { AutocompleteField, AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';
import { countries, CountryType } from './countries';

export type CountryAutocompleteProps = Omit<AutocompleteFieldProps<CountryType>, 'options'>;

export const CountryAutocompleteField = (props: CountryAutocompleteProps) => {
  return (
    <AutocompleteField<CountryType>
      options={countries}
      valueField="abbr"
      getOptionLabel={(option) => option.name}
      data-testid="country-autocomplete"
      {...props}
    />
  );
};
